<div class="inline-flex uppercase">
  {{ item().label }}
</div>
